/**
 * 根据环境变量动态插入 Bonree SDK
 */
export const insertBonreeScript = () => {
  const env = import.meta.env.VITE_APP_ENV

  // UAT 环境配置
  const uatConfig = {
    appId: 'd57e9296e6b041db9d877d07b13b4081',
    data: '%7B%22reqHeaderTraceKey%22%3A%5B%22tracestate%22%2C%22traceparent%22%5D%2C%22pendingRequestTimeout%22%3A30000%2C%22uploadAddrHttps%22%3A%22https%3A%2F%2Fjmsph-bonree-apm.jtexpress.ph%2FRUM%2Fupload%22%2C%22probability%22%3A1000%2C%22mc%22%3A%5B%7B%22n%22%3A%22network%22%2C%22cs%22%3A%7B%22fc%22%3A0%7D%7D%5D%2C%22appId%22%3A%22d57e9296e6b041db9d877d07b13b4081%22%2C%22uploadAddrHttp%22%3A%22http%3A%2F%2Fjmsph-bonree-apm.jtexpress.ph%2FRUM%2Fupload%22%2C%22hcs%22%3A2%2C%22respHeaderTraceKey%22%3A%5B%22traceresponse%22%2C%22x-br-response%22%5D%2C%22brss%22%3Afalse%7D'
  }

  // 生产环境配置
  const prodConfig = {
    appId: 'bc294b4c9d6147788e92798fc9030866',
    data: '%7B%22reqHeaderTraceKey%22%3A%5B%22tracestate%22%2C%22traceparent%22%5D%2C%22pendingRequestTimeout%22%3A30000%2C%22uploadAddrHttps%22%3A%22https%3A%2F%2Fjmsph-bonree-apm.jtexpress.ph%2FRUM%2Fupload%22%2C%22probability%22%3A1000%2C%22mc%22%3A%5B%7B%22n%22%3A%22network%22%2C%22cs%22%3A%7B%22fc%22%3A0%7D%7D%5D%2C%22appId%22%3A%22bc294b4c9d6147788e92798fc9030866%22%2C%22uploadAddrHttp%22%3A%22http%3A%2F%2Fjmsph-bonree-apm.jtexpress.ph%2FRUM%2Fupload%22%2C%22hcs%22%3A2%2C%22respHeaderTraceKey%22%3A%5B%22traceresponse%22%2C%22x-br-response%22%5D%2C%22brss%22%3Afalse%7D'
  }

  // 仅在 uat(pre) 或 production 环境插入
  if (env === 'uat' || env === 'pre' || env === 'production') {
    const config = env === 'uat' || env === 'pre' ? uatConfig : prodConfig
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://cms.jtexpress.com/common/JMS/Bonree/BonreeSDK_JS.min.js'
    script.setAttribute('data', config.data)
    script.id = 'BonreeAgent'
    script.async = true

    // 插入到 body 末尾
    document.body.appendChild(script)
  }
}

/**
 * 设置 Bonree RUM 用户 ID
 */
export const setBonreeUserId = (userId?: string | number) => {
  try {
    const br = (window as any).bonreeRUM
    if (userId && br && typeof br.setUserID === 'function') {
      br.setUserID(String(userId))
    }
  } catch (error) {
    console.error('bonreeRUM setUserID error:', error)
  }
}
